import {
  FETCH_ORGANIZATION_REQUEST,
  FETCH_ORGANIZATION_SUCCESS,
  FETCH_ORGANIZATION_FAILURE,
  FETCH_LINE_MASTER_REQUEST,
  FETCH_LINE_MASTER_SUCCESS,
  FETCH_LINE_MASTER_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SET_USER_CREDENTIALS,
  FETCH_SEASON_REQUEST,
  FETCH_SEASON_SUCCESS,
  FETCH_SEASON_FAILURE,
  FETCH_WAREHOUSE_FAILURE,
  FETCH_WAREHOUSE_SUCCESS,
  FETCH_WAREHOUSE_REQUEST,
  FETCH_AD_USER_REQUEST,
  FETCH_DGU_REMOTE_IP_REQUEST,
  FETCH_AD_USER_FAILURE,
  FETCH_AD_USER_SUCCESS,
  FETCH_DGU_REMOTE_IP_FAILURE,
  FETCH_DGU_REMOTE_IP_SUCCESS,
  FETCH_CLIENT_IP_REQUEST,
  FETCH_CLIENT_IP_SUCCESS,
  FETCH_CLIENT_IP_FAILURE,
  // FETCH_DRIER_TYPE_REQUEST,
  // FETCH_DRIER_TYPE_SUCCESS,
  // FETCH_DRIER_TYPE_FAILURE,
} from "./actionTypes";
import { initialState } from "./initialState";

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORGANIZATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ORGANIZATION_SUCCESS:
      return {
        ...state,

        loading: false,
        organizations: action.payload,
        error: null,
      };
    case FETCH_ORGANIZATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_LINE_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_LINE_MASTER_SUCCESS:
      return {
        ...state,

        loading: false,
        lineMasters: action.payload,
        error: null,
      };
    case FETCH_LINE_MASTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case SET_USER_CREDENTIALS:
      return {
        ...state,
        username: action.payload.username,
        password: action.payload.password,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LOGOUT:
      return initialState;

    case FETCH_SEASON_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_SEASON_SUCCESS:
      return {
        ...state,
        loading: false,
        season: action.payload,
      };
    case FETCH_SEASON_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

 
    case FETCH_WAREHOUSE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
        warehouse: action.payload,
        error: null,
      };

    case FETCH_WAREHOUSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // DGU Remote IP Cases
    case FETCH_DGU_REMOTE_IP_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_DGU_REMOTE_IP_SUCCESS:
      return { ...state, loading: false, dguRemoteIP: action.payload };

    case FETCH_DGU_REMOTE_IP_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // AD User Cases
    case FETCH_AD_USER_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_AD_USER_SUCCESS:
      return { ...state, loading: false, adUser: action.payload };

    case FETCH_AD_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_CLIENT_IP_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_CLIENT_IP_SUCCESS:
      return { ...state, loading: false, clientIP: action.payload };

    case FETCH_CLIENT_IP_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default filterReducer;
